import { forceArray } from 'navigation/component/Component';
import anime from 'animejs';
import { EASE_OUT } from 'helpers/easings';
import { bindEmitterMethod } from 'helpers/bind';
import mqStore from 'store/mqStore';
import MenuPanel from './MenuPanel';
import { durations } from './motion';
import MenuSecondPanelInner from './MenuSecondPanelInner';
export default class MenuSecondPanel extends MenuPanel {
    previousList = null;
    _list = null;
    autoOpen = false;
    get list() {
        return this._list;
    }
    set list(value) {
        this.previousList = this._list;
        const next = forceArray(this.modules.inners).find((inner) => inner.name === value);
        this._list = next ? value : null;
        if (this.previousList) {
            if (this.previousList !== value && value !== null) {
                if (!mqStore.narrowDesktop.get())
                    next?.enter(true);
                forceArray(this.modules.inners).find((inner) => inner.name === this.previousList)?.leave();
            }
            if (value === null)
                forceArray(this.modules.inners).find((inner) => inner.name === this.previousList || (inner.visible === true && inner.name === value))?.leave(!this.mobile);
            if (mqStore.narrowDesktop.get())
                next?.enter(true);
        }
        if (value && next && !this.previousList)
            this.open();
    }
    getModulesMap() {
        return {
            inners: ['.menu-level__second-inner', MenuSecondPanelInner]
        };
    }
    bindEvents(add) {
        super.bindEvents(add);
        const emitterMethod = bindEmitterMethod(add);
        forceArray(this.modules.inners).forEach((inner) => {
            inner[emitterMethod]('category:back', this.onCategoryBack);
        });
    }
    onCategoryBack = () => {
        this.close();
        this.emit('category:change', null);
    };
    open() {
        forceArray(this.modules.inners).find((inner) => inner.name === this.list)?.enter(this.mobile && this.autoOpen);
        if (this.mobile)
            this.openMobile();
        else
            this.openDesktop();
    }
    openMobile() {
        const m = anime({
            targets: this.el,
            translateX: {
                value: [0, 0]
            },
            opacity: {
                value: [0, 1],
                duration: durations.SECOND_PANEL_MOBILE_OPACITY_IN,
                easing: 'linear'
            },
            begin: () => {
                if (!this.autoOpen)
                    this.emit('open:begin');
            },
            complete: () => {
                this.emit('open:complete');
                this.autoOpen = false;
            }
        });
        this.motions.push(m);
    }
    openDesktop() {
        const m = anime({
            targets: this.el.firstElementChild,
            translateY: {
                value: ['-100%', 0],
                duration: durations.SECOND_PANEL_TRANSLATE_IN,
                easing: EASE_OUT
            },
            opacity: [1, 1]
        });
        this.motions.push(m);
    }
    forceClose() {
        if (this.mobile)
            this.forceCloseMobile();
        else
            this.forceCloseDesktop();
    }
    forceCloseMobile() {
        anime.set(this.el, {
            translateX: '-100%',
            opacity: 0
        });
        this.cancelMotions();
    }
    forceCloseDesktop() {
        anime.set(this.el.firstElementChild, {
            translateY: '-100%',
            opacity: 0
        });
        this.cancelMotions();
    }
    reset() {
        super.reset();
        this.el.style.transform = '';
        this.el.style.opacity = '';
        this.el.style.clipPath = '';
        this.list = null;
        this.autoOpen = false;
    }
    cancelMotions() {
        forceArray(this.modules.inners).forEach((inner) => inner.cancelMotions());
        super.cancelMotions();
    }
}
